<script setup lang="ts">
defineEmits<{
  select: []
}>();
const { locale } = useI18n();
</script>

<template>
  <div class="flex flex-col text-lg gap-xl">
    <MainHeaderMenuItemLink
      variant="submenu"
      :text="$t('core.navigation.section_about')"
      :to="{ name: 'about' }"
      menu-category1="discover_iad"
      menu-category2="about_iad"
      @click="$emit('select')"
    />
    <MainHeaderMenuItemLink
      v-if="locale === 'fr'"
      variant="submenu"
      :text="$t('core.header.menu.sell_buy_advice')"
      href="https://blog.iadfrance.fr/"
      target="_blank"
      menu-category1="discover_iad"
      menu-category2="buy_sell_advices"
      @click="$emit('select')"
    />
    <MainHeaderMenuItemLink
      variant="submenu"
      :text="$t('core.navigation.reviews')"
      :to="{ name: 'reviews' }"
      menu-category1="discover_iad"
      menu-category2="reviews"
      @click="$emit('select')"
    />
  </div>
</template>
